import { useEffect, useState } from 'react';
import './course.css';

export default function Course() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('http://185.164.73.170:5001/api/doreha')
            .then(res => res.json())
            .then(data => {
                const reversedCategories = data.categories.reverse(); // ترتیب معکوس
                setCategories(reversedCategories);
                setLoading(false);
            });
    }, []);

    return (
        <div className="coursepage">
            {loading ? (
                <div className='loading-container' style={{ margin: '0' }}>
                    <div className='loading-spinner'></div>
                    <p>در حال بارگذاری...</p>
                </div>
            ) : (
                <div className="coursepagedata">
                    {categories && categories.map((cat, index) => {
                        const hasCourses = cat.courses.some(course => course);
                        return (
                            <div
                                key={index}
                                className="coursepagecategory"
                                style={{ height: hasCourses ? '250px' : '100%' }}
                            >
                                <h2 style={{ borderBottom: hasCourses ? '1px solid rgba(255, 182, 182, 0.2)' : 'none' }}>
                                    {cat.name}{' '}
                                </h2>
                                {hasCourses ? (
                                    <ul className="listcourse">
                                        {cat.courses.map((course, index) =>
                                            course ? (
                                                <li key={index}>
                                                    <p>{course}</p>
                                                </li>
                                            ) : null
                                        )}
                                    </ul>
                                ) : (
                                    ''
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
